import { Directive, OnDestroy, OnInit, ViewContainerRef, inject, input } from '@angular/core';
import { ContainerService } from '../services';

export type ContainerType = 'Navigation' | 'Toolbar';

@Directive({
  selector: '[sharedContainer]',
})
export class ContainerDirective implements OnInit, OnDestroy {
  readonly sharedContainer = input.required<ContainerType>();

  private viewContainer = inject(ViewContainerRef);
  private containerService = inject(ContainerService);

  ngOnInit() {
    this.containerService.registerContainer(this.sharedContainer(), this.viewContainer);
  }

  ngOnDestroy() {
    this.containerService.unregisterContainer(this.sharedContainer());
  }
}
